var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCircle2Person68Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34C68 52.7777 52.7777 68 34 68C15.2223 68 0 52.7777 0 34Z",
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9 34.0001C32.181 34.0001 34.85 31.3311 34.85 28.0501C34.85 24.7691 32.181 22.1001 28.9 22.1001C25.619 22.1001 22.95 24.7691 22.95 28.0501C22.95 31.3311 25.619 34.0001 28.9 34.0001ZM28.9 25.5001C30.311 25.5001 31.45 26.6391 31.45 28.0501C31.45 29.4611 30.311 30.6001 28.9 30.6001C27.489 30.6001 26.35 29.4611 26.35 28.0501C26.35 26.6391 27.489 25.5001 28.9 25.5001ZM28.985 42.5001H21.709C23.392 41.6501 26.299 40.8001 28.9 40.8001C29.087 40.8001 29.291 40.8171 29.478 40.8171C30.056 39.5761 31.059 38.5561 32.266 37.7401C31.025 37.5191 29.852 37.4001 28.9 37.4001C24.922 37.4001 17 39.3891 17 43.3501V45.9001H28.9V43.3501C28.9 43.0611 28.934 42.7721 28.985 42.5001ZM41.65 38.2501C38.522 38.2501 32.3 39.9671 32.3 43.3501V45.9001H51V43.3501C51 39.9671 44.778 38.2501 41.65 38.2501ZM43.707 35.1561C44.999 34.4251 45.9 33.0481 45.9 31.4501C45.9 29.1041 43.996 27.2001 41.65 27.2001C39.304 27.2001 37.4 29.1041 37.4 31.4501C37.4 33.0481 38.301 34.4251 39.593 35.1561C40.205 35.4961 40.902 35.7001 41.65 35.7001C42.398 35.7001 43.095 35.4961 43.707 35.1561Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircle2Person68Px);
export default __webpack_public_path__ + "static/media/ic_circle_2_person_68px.5aff2e03ff8f2a9eb4b65379fbe444b4.svg";
export { ForwardRef as ReactComponent };